import * as React from "react";
import { PatientPersonalProfile } from "@curefit/ups-common";
import IinfoQues from "../../../models/staticData/IinfoQues";
import {isEmpty as _isEmpty} from "lodash";
import QuestionnaireView from "../../common/QuestionnaireView";
import {ITypeFormQuestionnaire} from "../../../models/ITypeFormQuestionnaire";
import TypeFormContainer from "../../../containers/TypeFormContainer";

interface PersonalInfoViewProps {
    staticPersonalInfo: IinfoQues;
    personalInfos: PatientPersonalProfile;
    updateHandler: (profile: PatientPersonalProfile) => void;
    questionnaire?: ITypeFormQuestionnaire[];
    questionIdList?: string[];
}
export default class PersonalInfoView extends React.Component<PersonalInfoViewProps> {
    personalInfoChangeHandler  = (updatedPersonalInfo: any, key: string) => {
        let personalInfos = {...this.props.personalInfos};
        if (_isEmpty(updatedPersonalInfo)) {
            delete  personalInfos[key];
        } else {
            personalInfos[key] = updatedPersonalInfo;
        }
        this.props.updateHandler(personalInfos);
    }
    render() {
        let {staticPersonalInfo} = this.props;
        return (<div className="personal-info-editor">
            {
                !_isEmpty(this.props.questionnaire) &&
                <TypeFormContainer typeFormData={this.props.questionnaire} questionIdList={this.props.questionIdList}/>
            }
            {staticPersonalInfo && staticPersonalInfo.questionnaire.map((question, index: number) => {
                let answer = this.props.personalInfos[question.key];
                return <div key={index} className="personal-info-ques-container">
                    <QuestionnaireView question={question} answer={answer} updateHandler={this.personalInfoChangeHandler}/>
                </div>
            })}
        </div>)
    }
}